<template>
  <div id="modal-menu">
    <div class="modal-content">
      <button type="button" class="close close-left" data-dismiss="modal" aria-label="Close" @click="closeModal()">
        <span aria-hidden="true">×</span></button>
      <form v-if="product" id="form-add-menu" method="post" action="">
        <div class="modal-body">
          <div class="modal-head pb-20">
            <div class="image-cover sides">
              <img v-if="product.image"
                   v-bind:src="(product.image.desktop_detail) ? product.image.desktop_detail : $const.IMG_PIZZA_DEFAULT"
                   class="desktop-only">
              <img v-if="product.image"
                   v-bind:src="(product.image.desktop_thumbnail) ? product.image.desktop_thumbnail : $const.IMG_PIZZA_DEFAULT"
                   class="mobile-only">
            </div>
            <h1 class="t22 fw600 title-name">{{ product.name }}</h1>
            <div class="flex flex-row flex-wrap pt-10 pb-10">
              <div v-for="(img, indeximg) in product.menu_attributes" :key="indeximg" class="pl-10">
                <img alt="" v-bind:src="img.image.icon"  width="30" class="pl-5" />
                {{img.name}}
              </div>
            </div>
            <p class="t13 fw300 pr10 pt10 text-black des" style="" v-if="product.marketing_description">
              <nl2br tag="p" :text="product.marketing_description"/>
            </p>
            <p class="t13 fw300 pr10 pt10 text-black des" style="" v-if="product.main_description">
              <nl2br tag="p" :text="product.main_description"/>
            </p>



            <!--BEGIN List ADDED extra topping-->
            <span class="add-toppings-str pl-10" v-if="addedExtraToppings && addedExtraToppings.length > 0">
              <span
                class="text-green"><strong>{{$t('cart.add')}}:</strong></span>
              <div class="list-added-topping">
                <ul class="p-0">
                  <li class="btn btn--primary btn-icon-label btn-icon-label--added ml-5 mb-5"
                      @click="removeSelectedExtraTopping(item); deactiveScroll()"
                      v-for="(item) in addedExtraToppings">
                    <span class="btn-inner--text">{{item.name}}</span>
                    <span class="btn-inner--icon">
                      <i class="icon glyphicon glyphicon-remove-circle"></i>
                    </span>
                  </li>
                </ul>
              </div>
            </span>
            <!-- ./END list ADDED extra topping-->




            <!--BEGIN List REMOVED default topping-->
            <span class="remove-toppings-str pl-10" v-if="removedDefaultToppings && removedDefaultToppings.length > 0">
              <span
                class="text-orange"><strong>{{$t('cart.remove')}}:</strong></span>
              <div class="list-removed-topping">
                <ul class="p-0">
                  <li class="btn btn--primary btn-icon-label btn-icon-label--removed ml-5 mb-5"
                      @click="reAddSelectedDefaultTopping(item); deactiveScroll()"
                      v-for="(item) in removedDefaultToppings">
                    <span class="btn-inner--text">{{item.name}}</span>
                    <span class="btn-inner--icon">
                        <i class="icon glyphicon glyphicon-plus-sign"></i>
                      </span>
                  </li>
                </ul>
              </div>
            </span>
            <!--END ./List REMOVED default topping-->




          </div>
          <div class="flex1auto selector-container" style="max-height: calc(100vh - 515px);">
            <!-- ############################## Choose size & crust ########################## -->
            <div class="box-select-variant-addon" v-if="!choosedName">
              <p class="fw600 t15 mb15 text-black bg-grey-lightest md:bg-transparent p10 "
                 v-if="product && product.first_layers && product.first_layers.length > 0">
                {{$t('menu.select_size_crust')}}</p>
              <div v-for="item in product.first_layers" :key="genUniqueKey(item)">
                <div class="t15 fw600 heading-line-right mt10 mb10 text-black p10 bg-white md:bg-transparent">
                  {{item.name}}
                </div>
                <div v-for="subitem in item.second_layers" :key="genUniqueKey(subitem)"
                     class="variant-addon-item option display-flex t15 p10 text-black bg-grey-lightestest md:bg-transparent active"
                     @click="chooseVariant(item, subitem)">
                  <div class="flex1 display-flex items-center justify-start text-black fw400">
                    <div>
                      <img v-if="subitem.image" width="35" v-bind:alt="subitem.name"
                           v-bind:src="(subitem.image.desktop_detail) ? subitem.image.desktop_detail : $const.IMG_CRUST_DEFAULT"
                           class="option---icon">
                    </div>
                    <div class="pl-10 option---content ">
                      <div>{{subitem.name}}</div>
                      <div class="option__long-description t13 fw400"></div>

                    </div>
                  </div>
                  <div class="fw600 text-right pl10 pr10 flex-center" v-bind:class="[{ 'd-none': !isShowQuantity }]"
                       v-if="product && product.first_layers && product.first_layers.length >= 1">
                    {{
                    $t('currency_display', {
                    currency: $const.CURRENCY,
                    amount: formatNumDisplay(sumNum(product.price, item.price, subitem.price))
                    })
                    }}
                  </div>
                  <div v-bind:class="[{ 'd-none': !isShowQuantity }]" class="fw600 text-right pl10 pr10 flex-center" v-else>
                    {{
                    $t('currency_display', {
                    currency: $const.CURRENCY,
                    amount: formatNumDisplay(product.price)
                    })
                    }}
                  </div>
                </div>
              </div>
            </div>
            <!-- ################################################################################### -->
            <!-- ############################ Topping ###################################### -->
            <div class="p10 box-topping-contain" v-if="choosedName">
              <div class="variant-addon-choosen p10">
                <div class="display-flex t15">
                  <span class="flex1 name fw400  text-black">{{convertString(choosedName)}}</span>
                  <a @click="changeSize" class="cursor-pointer cl-78838c border-b t13">{{$t('button_change')}}</a>
                </div>
                <hr>
              </div>
              <div class="menu-toppings">
                <div class="topping-header cheese text-black " style="" v-if="showExtra">{{$t('change_cheese')}}
                </div>
                <div class="extra-cheese option option-cheese bg-grey-lightestest md:bg-transparent"
                     v-bind:class="{'opacity-3':checkDisableExtra(topping.uuid)}" style=""
                     v-for="(topping) in extraTopping" :key="genUniqueKey(topping)" v-if="topping.special == '1'">
                  <div class="xs-mt-20">
                    <div class="extra-cheese-option" style="">
                      <label class="xs-items-center xs-px-10 rounded label-radio" :for="topping.uuid">
                        <input class="xs-block rounded xs-p-5 radio ExtraCheese" :id="topping.uuid" name="ExtraCheese"
                               :value="topping" v-model="choosedCheese" type="checkbox"
                               :disabled="checkDisableExtra(topping.uuid)">
                        <i class="pull-left xs-my-15"></i>
                        <span class="xs-mr-auto typo-l5 xs-items-center xs-py-15">
                                    <i class="xs-hide md-block xs-mr-10"></i>
                                    <span class="fw400 text-black t15">{{topping.name}}</span>
                            </span>
                        <span class="pull-right extra-cheese-price t15 fw600 cl-525252">+
                                {{
                                    $t('currency_display', {
                                        currency: $const.CURRENCY,
                                        amount: formatNumDisplay(getPriceTopping(topping.prices))
                                    })
                                  }}
                            </span>
                      </label>
                    </div>
                    <div class="xs-mb-10"></div>
                  </div>
                </div>

                <!--BEGIN EXTRA topping list-->
                <div class="topping-header" style=""
                     v-if="extraToppingsV2 && extraToppingsV2.length > 0"
                     @click="showToppingPlus = !showToppingPlus"
                     :class="{active: showToppingPlus}">
                  {{$t('add_toppings')}}
                </div>
                <div v-model="showToppingPlus">
                  <div class="add-toppings text-black" style="position: relative"
                       :class="{'option--disabled': addedExtraToppings.length >= maxExtra}"
                       v-if="extraToppingsV2 && extraToppingsV2.length > 0">
                    <transition-group name="fade">
                      <div
                        v-for="(extopping,index) in extraToppingsV2"
                        :key="genUniqueKey(extopping)"
                        v-if="extopping.special != '1'"
                        class="add-toppings-item display-flex t15 p10 option bg-grey-lightestest md:bg-transparent"
                        :data-item-uuid="extopping.uuid"
                        v-bind:class="{'disable': extopping.isDisable}"
                      >
                        <div class="flex1 fw400">
                          <span class="pl-10">{{convertString(extopping.name)}}</span>
                        </div>
                        <div v-bind:class="[{ 'd-none': !isShowQuantity }, 'text-right', 'pl10', 'pr10', 'topping-price', 'fw600 cl-525252']"
                             v-if="!extopping.default">+
                          {{
                          $t('currency_display', {
                          currency: $const.CURRENCY,
                          amount: formatNumDisplay(extopping.price)
                          })
                          }}
                        </div>
                        <div :class="[{ 'd-none': !isShowQuantity }, 'app-quantity-selector']">
                          <button type="button"
                                  class="btn btn--primary btn-quantity btn-quantity--minus"
                                  :class="{'option--disabled': extopping.count <= 0}"
                                  @click.once="removeSelectedExtraTopping(extopping); setScrollPositionMoveTo(extopping.uuid)"
                          ></button>
                          <span class="mr-5 ml-5">{{(extopping.count) ? extopping.count : 0}}</span>
                          <button type="button"
                                  class="btn btn--primary btn-quantity btn-quantity--add"
                                  @click.once="addSelectedExtraTopping(extopping); setScrollPositionMoveTo(extopping.uuid)"
                                  :class="{'option--disabled': extopping.count >= $const.TOPPING.MAX_PER_TOPPING}"
                          ></button>
                        </div>

                      </div>
                    </transition-group>
                  </div>
                </div>
                <!--END ./ EXTRA topping list-->

                <!--BEGIN DEFAULT topping list-->
                <div class="topping-header mt-30" style=""
                     v-if="defaultToppingsV2 && defaultToppingsV2.length > 0 "
                     @click="showToppingMinus = !showToppingMinus"
                     :class="{active: showToppingMinus}">
                  {{$t('your_toppings')}}
                </div>
                <div v-model="showToppingMinus">
                  <div class="your-toppings text-black" style="position: relative"
                       v-if="defaultToppingsV2 && defaultToppingsV2.length > 0 ">
                    <transition-group name="fade" v-on:before-leave="beforeLeaveTopping"
                                      v-on:after-leave="afterLeaveTopping">
                      <div class="your-toppings-item display-flex t15 p10 cursor-pointer option visible" style=""
                           v-for="(topping,index) in defaultToppingsV2"
                           :data-item-uuid="topping.uuid"
                           :key="genUniqueKey(topping)">
                        <div class="flex1 fw400">
                          <span class="pl-10">{{convertString(topping.name)}}</span>
                        </div>

                        <div v-bind:class="[{ 'd-none': !isShowQuantity }]" class="app-quantity-selector">
                          <button type="button"
                                  class="btn btn--primary btn-quantity btn-quantity--minus"
                                  :class="{'option--disabled': topping.count <= 0}"
                                  @click.once="removeSelectedDefaultTopping(topping); setScrollPositionMoveTo(topping.uuid)"
                          ></button>
                          <span class="mr-5 ml-5">{{topping.count}}</span>
                          <button type="button"
                                  class="btn btn--primary btn-quantity btn-quantity--add"
                                  :class="{'option--disabled': topping.count >= $const.TOPPING.MAX_PER_DEFAULT_TOPPING}"
                                  @click.once="reAddSelectedDefaultTopping(topping); setScrollPositionMoveTo(topping.uuid)"
                          ></button>
                        </div>

                      </div>
                    </transition-group>
                  </div>
                </div>
                <!--END ./ DEFAULT topping list-->

              </div>
            </div>
            <!-- ############################################################################ -->

            <div class="tcbox">
              <div role="button" @click="showAccordionTC = !showAccordionTC" v-if="t_c_desc">
                <h6 class="panel-title t14 fw600">
                  <i class="fa fa-caret-down" v-if="showAccordionTC"></i>
                  <i class="fa fa-caret-up" v-if="!showAccordionTC"></i>
                  <span class="pl-5">{{$t('t_and_c')}}</span>
                </h6>
              </div>
              <collapse v-model="showAccordionTC" v-if="t_c_desc">
                <div class="menu-description term" style="color:#d9b084">
                  <nl2br class="des " tag="p" :text="t_c_desc"/>
                </div>
              </collapse>
            </div>

          </div>
          <div class="modal-action" v-if="product.type === $const.CARD_ITEM_TYPE.FREE">
            <button type="button"
              @click="hutReward.point >= product.point ? addToBasket() : ''"
              class="btn btn--lg js-action-btn-add"
              :class="hutReward.point >= product.point ? ' btn--primary' : ' btn--secondary'"
              >
              {{$t('add_to_my_basket')}}
              <span v-bind:class="[{ 'd-none': !isShowQuantity }]">
                  {{
                      $t('currency_display', {
                          currency: $const.CURRENCY,
                          amount: formatNumDisplay(product.price)
                      })
                  }}
              </span>
            </button>
          </div>
          <div class="modal-action" v-else>
            <button type="button" @click="addToBasket()" class="btn btn--primary btn--lg js-action-btn-add"
                    v-bind:class="[{disabled : disableAdd}]"
                    v-if="product.first_layers && product.first_layers.length > 0">{{$t('add_to_my_basket')}}
              <span v-bind:class="[{ 'd-none': !isShowQuantity }]">
                {{
                  $t('currency_display', {
                      currency: $const.CURRENCY,
                      amount: formatNumDisplay(totalPrice)
                  })
                }}
              </span>
            </button>
            <button type="button" @click="addToBasket()" class="btn btn--primary btn--lg js-action-btn-add" v-else>
              {{$t('add_to_my_basket')}}
              <span v-bind:class="[{ 'd-none': !isShowQuantity }]">
                  {{
                      $t('currency_display', {
                          currency: $const.CURRENCY,
                          amount: formatNumDisplay(product.price)
                      })
                  }}
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import {mapGetters} from 'vuex'
import * as types from '@/store/types'
//const cloneDeep = require("lodash.clonedeep");
import { getExperiment } from '@pizza-hut/lib-experiments/lib'
import DispositionPopup from '../home/HomeLocalizationMapZipcodeNewDesign'

export default {
  props: ['uuid', 'menu', 'mfirst', 'msecond', 'extraCheese', 'coupon', 'isUpdate', 'showQuantity'],
  created() {
    const { size, crust } = this.getBothSelectedSizeNCrust

    if (!_.isEmpty(size) && !_.isEmpty(crust)) {
      this.choosedFirst = size
      this.choosedSecond = crust
    }

    this.resetAddedExtraTopping()
    this.resetRemovedDefaultTopping()
    this.resetQuantityToppings()
  },
  mounted() {
    const experiment = getExperiment('CVR', 'newDisposition')
    if (experiment === this.getValueExperiment('newDisposition', 'clickToOpenPopup')) {
      this.showNewVariantDisposition = true
    }
    this.itemId = this.selectedCart ? this.selectedCart.cartId : null
    this.$cart.init(this)
    if (!this.menu) {
      this.getProductByUUID();
    }

    this.getTopping()
    if (!this.empty(this.mfirst) && !this.empty(this.msecond)) {
      this.chooseVariant(this.mfirst, this.msecond, false)
    }

    // check if existed state `selectedSize` & `selectedCrust`
    const { size, crust } = this.getBothSelectedSizeNCrust

    if (!_.isEmpty(size) && !_.isEmpty(crust)) {
      this.chooseVariant(size, crust, false)
    }

    if (this.shouldTriggerChooseTopping) {
      const pizzaSize = this.menu.first_layers

      if (pizzaSize && pizzaSize.length === 1) {
        const pizzaCrust = this.menu.first_layers[0].second_layers

        if (pizzaCrust && pizzaCrust.length === 0
          || pizzaCrust.length === 1
        ) {
          this.chooseVariant(pizzaSize[0], pizzaCrust[0], false)
        }
      }
    }

    // this.eventTrackingProductDetail(this, this.menu, this.$const.CARD_ITEM_TYPE.SINGLE)
  },
  updated() {
    if (this.currentSelectedToppingUuid !== '' && this.willScroll) {
      this.scrollToItem(this.currentSelectedToppingUuid)
    }
  },
  destroyed() {
    let sub = this.$route.params.sub;
    let uuid = this.$route.params.uuid;
    let vm = this;
    document.body.classList.remove('modal-open')

    this.$store.commit('setSelectedCart', null)
    if (this.$route.name === 'free_side') {
      return false
    } else if (this.$route.params.slug) {
      if (uuid) {
        this.redirectToMenuPage(this.$route.params.slug, sub, null, true);
      } else if (vm.$session.has('disposition') && vm.$session.get('disposition').outletId !== undefined) {
        this.redirectToMenuPage(this.$route.params.slug, null, null, true);
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedCart: 'selectedCart',
      shouldTriggerChooseTopping: 'shouldTriggerChoosingTopping',
      getSelectedSize: types.GET_SELECTED_SIZE,
      getSelectedCrust: types.GET_SELECTED_CRUST,
      getBothSelectedSizeNCrust: types.GET_BOTH_SELECTED_SIZE_N_CRUST,
      extraToppingsV2: types.GET_EXTRA_TOPPINGS,
      addedExtraToppings: types.GET_ADDED_EXTRA_TOPPINGS,
      defaultToppingsV2: types.GET_DEFAULT_TOPPINGS,
      removedDefaultToppings: types.GET_REMOVED_DEFAULT_TOPPINGS,
      hutReward: types.GET_HUT_REWARD
    })
  },
  watch: {
    choosedCheese(val) {
      this.updateTotalPrice()
      if (parseInt(this.addExtraTopping.length) + parseInt(val.length) >= this.maxExtra) {
        this.showAllExtraTopping(true)
      } else {
        this.showAllExtraTopping(false)
      }
    },
    product(newVal, oldVal) {
      let vm = this
      this.maxExtra = this.product && this.product.extraToppingMax ? this.product.extraToppingMax : this.$const.MAX_TOPPING;
      this.t_c_desc = this.product && this.product.t_and_c;
    },
    selectedCart(newVal, oldVal) {
      this.itemId = this.selectedCart ? this.selectedCart.cartId : null
    }
  },
  data: function () {
    return {
      choosedName: '',
      defaultsTopping: [],
      defaultsextraTopping: [],
      yourTopping: [],
      extraTopping: [],
      choosedFirst: {},
      choosedSecond: {},
      removeYourTopping: [],
      addExtraTopping: [],
      totalPrice: 0,
      totalExtraTopping: 0,
      transitionLeave: true,
      choosedCheese: [],
      gotCheese: {'status': 'N', 'price': 0},
      maxExtra: this.menu && this.menu.extraToppingMax ? this.menu.extraToppingMax : this.$const.MAX_TOPPING,
      addExtraToppingWithPrice: [],
      disableAdd: true,
      t_c_desc: this.menu && this.menu.t_and_c,
      showAccordionTC: false,
      choosedHalf: false,
      showExtra: false,
      showToppingMinus: false,
      showToppingPlus: false,
      product: this.menu ? this.menu : null,
      itemId: this.selectedCart ? this.selectedCart.productUuid : null,
      currentSelectedToppingUuid: '',
      willScroll: false,
      isShowQuantity: Object.entries(this.$disposition.get(this)).length !== 0,
      showNewVariantDisposition: true // in case JP want to revert DWL
    }
  },
  methods: {
    getProduct() {
      let vm = this
      let orderTime = this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''),
        this.$disposition.getByKey(this, 'collectionTimeValue', ''))
      if (!orderTime) {
        orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }

      orderTime = this.convertSecond(orderTime)

      let data = {
        tier: this.$disposition.getByKey(this, 'tier', '1'),
        order_type: this.$disposition.getByKey(this, 'orderType', 'D').charAt(0),
        order_time: orderTime,
        outlet_code: this.getOutletCode(this)
      }

      vm.axios.getMenuDetails(vm.uuid, data, function (response) {
        vm.product = response.data.data.item
        vm.getTopping();
      }, function (error) {
        console.log(error)
        if (error.data) {
          vm.$notify({
            type: 'error',
            title: error.data
          })
        }
      })
    },
    checkDisableExtra(uuid) {
      let exist = false
      for (let i in this.choosedCheese) {
        if (uuid == this.choosedCheese[i].uuid) {
          exist = true
        }
      }
      if (!exist && parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) >= this.maxExtra) {
        return true
      }

      if (exist && parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) < this.maxExtra) {
        return false
      }

      return false
    },
    /**
     * Trigger before leave topping event
     */
    beforeLeaveTopping(el) {
      this.transitionLeave = false
    },
    /**
     * Trigger after leave topping event
     */
    afterLeaveTopping(el) {
      this.transitionLeave = true
    },
    /**
     * Chosen first and second layer
     */
    chooseVariant(first, second, istrack = true) {
      this.choosedFirst = first
      this.choosedSecond = second
      this.choosedName = first.name + ' ' + second.name
      this.updateTotalPrice()
      this.$set(this.gotCheese, 'status', this.product.extraCheese)
      this.$set(this.gotCheese, 'price', this.getCheese(first.name))
      this.disableAdd = false

      let dataProduct = {...this.product}
      let firstLayer = {...first}
      let secondLayer = {...second}

      dataProduct.first_layers = []
      dataProduct.first_layers.push(firstLayer)

      if (firstLayer != null && !this.empty(firstLayer)) {
        dataProduct.first_layers[0].second_layers = [secondLayer]
      }
      dataProduct.price = this.totalPrice

      this.getTopping()
      let variantUUid = ''
      if (!this.empty(firstLayer) && firstLayer.uuid != '') {
        variantUUid = firstLayer.uuid
      }
      if (!this.empty(secondLayer) && secondLayer.uuid != '') {
        variantUUid += '-' + secondLayer.uuid
      }
      if (istrack) {
        let proClick = this._.cloneDeep(this.product)
        proClick.variant_uuid = variantUUid
        this.evenTrackingProductClick(this, proClick, 'product-selection-from-variant-list')
      }
      this.eventTrackingProductDetail(this, dataProduct, this.$const.CARD_ITEM_TYPE.SINGLE, 'product-details')
      this.eventTrackingProductView(dataProduct.uuid, variantUUid)
    },
    /**
     * Get cheese price belong size pizza
     * */
    getCheese(size) {
      let price = 0
      for (let cheese in this.extracheese) {
        if (this.extracheese[cheese].Size == this.convertString(size)) {
          price = this.extracheese[cheese].Price
        }
      }
      return price
    },
    /**
     * Get topping price
     * */
    getPriceTopping(topping) {
      let vm = this
      let price = 0

      if (topping) {
        price = topping[vm.choosedFirst.sku] ? topping[vm.choosedFirst.sku] : 0
      } else {
        price = 0
      }

      return price
    },
    /**
     * Reset item choiced
     * */
    resetDataItem() {
      this.choosedFirst = {}
      this.choosedSecond = {}
      this.choosedName = ''
      this.totalPrice = 0
      this.removeYourTopping = []
      this.addExtraTopping = []
      this.yourTopping = JSON.parse(JSON.stringify(this.defaultsTopping))
      this.extraTopping = JSON.parse(JSON.stringify(this.defaultsextraTopping))
      this.totalExtraTopping = 0
      this.choosedCheese = []

      // update new UI/UX (epic: pa-897)
      this.resetAddedExtraTopping()
      this.resetRemovedDefaultTopping()
      this.resetQuantityToppings()
    },
    /**
     * reset first and second layer
     * */
    changeSize() {
      this.resetDataItem()
      this.updateTotalPrice()
      this.disableAdd = true
    },
    /**
     * change your topping
     * type: 1: remove topping, 2 add topping
     * */
    changeTopping(topping, type, index) {
      let newTopping = this._.cloneDeep(topping)
      if(topping.prices){
        topping.price = this.getPriceTopping(topping.prices)
      }else{
        topping.price = 0
      }

      if (this.transitionLeave) {
        if (type == 1) {
          this.eventTrackingVariantUnSelect({item: this.menu, topping: topping, first: this.choosedFirst})

          this.yourTopping.splice(index, 1);

          /*let hasTopping = false
          for (let e in this.extraTopping) {
            if (this.extraTopping[e].id == topping.id) {
              hasTopping = true
              break
            }
          }
          if (!hasTopping) {
            this.extraTopping.unshift(topping)
          }*/
          // if remove isExtra topping
          if (!topping.default || (topping.default && !this.checkToppingType(topping, 2))) {
            this.sliceTopping(newTopping, index, 3)
            this.updateTotalPrice()
          } else {
            this.extraTopping.unshift(newTopping)
            this.removeYourTopping.push(newTopping)
          }
          this.updateExtra({topping: newTopping, type: type})
          this.checkDisableTopping(newTopping, type)
        } else if (type == 2) {

          if (!topping.isDisable) {
            if (topping.default) {
              this.extraTopping = this.extraTopping.filter(function (value, index, arr) {
                return value.id != topping.id
              })
            }
            this.eventTrackingVariantSelect({item: this.menu, topping: topping, first: this.choosedFirst})

            newTopping.default = this.checkToppingType(newTopping, 2)
            if (!newTopping.default) {
              this.addExtraTopping.push(newTopping)
              this.updateTotalPrice()
            } else {
              this.sliceTopping(newTopping, index, 2)
            }

            if(newTopping.default){
              this.yourTopping.push(newTopping)
            }else{
              this.yourTopping.unshift(newTopping)
            }

            this.updateExtra({topping: newTopping, type: type})
            this.checkDisableTopping(newTopping, type)
          }
        }

        this.setActiveToppingList(this.extraTopping, this.yourTopping);
      }
    },

    /**
     * update total price
     * */
    updateTotalPrice() {
      this.totalExtraTopping = 0

      if (this.addedExtraToppings.length > 0) {
        this.totalExtraTopping = this.addedExtraToppings.reduce((totalExtraToppingsPrice, topping) => {
          totalExtraToppingsPrice += parseFloat(topping.price)

          return totalExtraToppingsPrice
        }, this.totalExtraTopping)
      }

      this.totalPrice = this.product.price > 0 ? parseFloat(this.product.price) : 0
      this.totalPrice += this.totalExtraTopping

      if (typeof this.choosedFirst.price !== 'undefined') {
        this.totalPrice += parseFloat((this.choosedFirst.price > 0 ? this.choosedFirst.price : 0))
      }
      if (typeof this.choosedSecond.price !== 'undefined') {
        this.totalPrice += parseFloat((this.choosedSecond.price > 0 ? this.choosedSecond.price : 0))
      }

      let extraPrice = 0
      for (let i in this.choosedCheese) {
        extraPrice += parseFloat(this.getPriceTopping(this.choosedCheese[i].prices))
      }

      this.totalPrice += parseFloat(extraPrice)
    },
    /**
     * Slice topping
     * type: 1: your topping, 2 remove your topping, 3 add topping (default)
     * */
    sliceTopping(topping, index, type) {
      if (type == 1) {
        for (let y in this.yourTopping) {
          if (this.yourTopping[y].id == topping.id) {
            this.yourTopping.splice(y, 1)
            break
          }
        }
      } else if (type == 2) {
        for (let y in this.removeYourTopping) {
          if (this.removeYourTopping[y].id == topping.id) {
            this.removeYourTopping.splice(y, 1)
            break
          }
        }
      } else {
        for (let y in this.addExtraTopping) {
          if (this.addExtraTopping[y].id == topping.id) {
            this.addExtraTopping.splice(y, 1)
            break
          }
        }
      }
    },
    /**
     * set your and extra toppings
     * */
    getTopping() {
      if (this.product && this.product.toppings && this.product.toppings.default && this.product.toppings.extra) {
        let data = JSON.parse(JSON.stringify(this.product.toppings.default))
        for (let topping in data) {
          data[topping].default = true
          data[topping].isDisable = false
        }
        this.yourTopping = data
        this.extraTopping = JSON.parse(JSON.stringify(this.product.toppings.extra))
        this.showExtra = false
        for (let topping in this.extraTopping) {
          this.extraTopping[topping].default = false

          if (this.maxExtra == 0) {
            this.extraTopping[topping].isDisable = true
          } else {
            this.extraTopping[topping].isDisable = false
          }
          if (this.extraTopping[topping].special == '1') {
            this.showExtra = true
          }
        }

        this.defaultsTopping = JSON.parse(JSON.stringify(this.yourTopping))
        this.defaultsextraTopping = JSON.parse(JSON.stringify(this.extraTopping))



        // First init Toppings STATE (Update v2 20191231)
        let extraToppings = JSON.parse(JSON.stringify(this.product.toppings.extra))
        extraToppings.map(item => {
          item.count = this.$const.TOPPING.EXTRA_TOPPING_COUNT
          item.min = this.$const.TOPPING.MIN_PER_TOPPING
          item.max = this.$const.TOPPING.MAX_PER_TOPPING

          if (this.maxExtra === 0) {
            item.isDisable = true
          } else {
            item.isDisable = false
          }

          // Inject price base on choosedFirst
          if (item.prices !== undefined) {
            item.price = this.getPriceTopping(item.prices)
          } else {
            item.price = 0
          }

          return item
        })

        let defaultToppings = JSON.parse(JSON.stringify(this.product.toppings.default))
        defaultToppings.map(item => {
          item.count = this.$const.TOPPING.DEFAULT_TOPPING_COUNT
          item.min = this.$const.TOPPING.MIN_PER_TOPPING
          item.max = this.$const.TOPPING.MAX_PER_DEFAULT_TOPPING
          item.isDisable = false

          return item
        })

        this.$store.dispatch(types.SET_EXTRA_TOPPINGS, extraToppings)
        this.$store.dispatch(types.SET_DEFAULT_TOPPINGS, defaultToppings)
      }
    },
    /**
     * check topping is extra or default
     * type: 1 isExtra, 2 Default
     * */
    checkToppingType(topping, type) {
      let i = 0
      for (let t in this.defaultsTopping) {
        if (this.defaultsTopping[t].id == topping.id) {
          i++
        }
      }
      if (i == 0) {
        return type == 1
      }
      i = 0
      for (let t in this.yourTopping) {
        if (this.yourTopping[t].id == topping.id) {
          i++
        }
      }
      if (type == 1) {
        return i > 0
      }
      return i == 0
    },
    /**
     * re-update extra and default toppings
     * type: 1 remove topping, 2 add topping
     * */
    updateExtra({topping, type}) {
      for (let t in this.extraTopping) {
        if (this.extraTopping[t].id == topping.id) {
          if (type == 1) {
            if (topping.default && this.yourTopping.length > 0) {
              this.extraTopping[t].default = true
              for (let y in this.yourTopping) {
                if (this.yourTopping[y].id == topping.id) {
                  this.yourTopping[y].default = true
                  this.extraTopping[t].default = false
                  break
                }
              }
            } else {
              this.extraTopping[t].default = topping.default
            }
          } else {
            this.extraTopping[t].default = false
          }
          break
        }
      }
    },
    /**
     * Check to show/hide extra topping
     * type: 1 remove topping, 2 add topping (default)
     * */
    checkDisableTopping(topping, type) {
      if (parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) >= this.maxExtra) {
        this.updateDisableExtraTopping()
      } else {
        if (topping.default) {
          if (type == 1) {
            if (this.removeYourTopping.length > 0 && parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) >= this.maxExtra) {
              for (let t in this.extraTopping) {
                for (let rm in this.removeYourTopping) {
                  if (this.extraTopping[t].id == this.removeYourTopping[rm].id) {
                    this.extraTopping[t].isDisable = false
                    break
                  }
                }
              }
            } else {
              this.showAllExtraTopping(false)
            }
          } else if (type == 2) {
            for (let t in this.extraTopping) {
              for (let rm in this.removeYourTopping) {
                if (this.extraTopping[t].id == this.removeYourTopping[rm].id) {
                  this.extraTopping[t].isDisable = false
                  break
                }
              }
            }
          }
        } else {
          if (type == 1) {
            this.showAllExtraTopping(false)
          } else {
            let disable
            if (this.removeYourTopping.length > 0 && parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) < this.maxExtra) {
              for (let t in this.extraTopping) {
                for (let rm in this.removeYourTopping) {
                  if (this.extraTopping[t].id == this.removeYourTopping[rm].id) {
                    disable = false
                    break
                  } else {
                    if (!this.extraTopping[t].default) {
                      disable = false
                    }
                  }
                  this.extraTopping[t].isDisable = disable
                }
              }
            } else {
              if (parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) == this.maxExtra) {
                for (let t in this.extraTopping) {
                  this.extraTopping[t].isDisable = true
                }
              }
            }
          }
        }
      }
    },
    /**
     * Checking to show/hide extra topping
     * */
    updateDisableExtraTopping() {
      for (let t in this.extraTopping) {
        let disable = true
        if (this.removeYourTopping.length > 0) {
          for (let rm in this.removeYourTopping) {
            if (this.extraTopping[t].id == this.removeYourTopping[rm].id) {
              disable = false
              break
            }
          }
        } else {
          if (!this.extraTopping[t].default) {
            disable = true
          }
        }
        this.extraTopping[t].isDisable = disable
      }
    },
    /**
     * Show extra topping
     * */
    showAllExtraTopping(flag) {
      for (let t in this.extraTopping) {
        this.extraTopping[t].isDisable = flag
      }
    },

    getToppingById(a) {
      var arr = []
      for (let i = 0; i < a.length; i++) {
        arr.push(a[i].id)
      }
      return arr
    },

    checkSubmit() {
      if (this.product && this.product.first_layers && this.product.first_layers.length > 0) {
        if (this.choosedFirst && this.choosedFirst.uuid) {
          return true
        } else {
          return false
        }
      } else if (this.product && this.product.uuid) {
        return true
      }
      return false
    },

    /**
     * Adding item to cart
     * Prepare new format to API
     * */
    addToBasket () {
      if (!this.checkPosition(this)) {
        this.$emit('close')
        let path = this.$route.fullPath
        if(!this.showNewVariantDisposition){
          this.$router.push({'name': 'home', query: {isShowWarning: 1, callback: path}})
        }else{
          const dataParams = {
            name: this.$route.name,
            params: this.$route.params
          }
          this.$modal.show(DispositionPopup,{isPopup : true, currentPath: dataParams},{class: 'modal-localization'})
        }
      } else {
        if (this.checkSubmit()) {
          let item = {
            'group': {},
            'selling_start': this.product.selling_start,
            'products': []
          }

          if (this.coupon) {
            item.group.coupon_code = this.coupon
          }
          item.group['outlet_code'] = this.getOutletCode(this)
          item.group['tier'] = this.$disposition.getByKey(this, 'tier', '1')
          item.group['order_type'] = this.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
          item.group['order_time'] = this.getTimePickerDate(this)
          item.group['product_type'] = this.product.product_type
          item.group['combo_id'] = null
          item.group['quantity'] = 1
          item.group['category_uuid'] = this.$store.getters.category_uuid

          let product = {}
          product.category_id = this.$store.getters.category_uuid
          product.combo_group_id = ''
          product.product_id = this.product.uuid
          product.first_id = this.choosedFirst.uuid
          product.second_id = this.choosedSecond.uuid
          product.toppings = {}
          product.toppings.remove = this.$cart.getToppingById(this.removedDefaultToppings)
          let newExtraTopping = this._.union(this.addedExtraToppings, this.choosedCheese)
          product.toppings.extra = this.$cart.getToppingById(newExtraTopping)
          item.products.push(product)
          this.$emit('close')
          if (this.itemId) {
            item.group['item_id'] = this.itemId
            this.$cart.updateCart(this, item)
          } else {
            this.$cart.insert(this, item)
          }
          let pro = {
            item: this.menu,
            id: this.product.uuid,
            name: this.product.name,
            price: this.totalPrice,
            first: this.choosedFirst || {},
            second: this.choosedSecond || {}
          }
          this.resetDataItem()

          // reset state selected Size&Crust in STORE
          this.$store.dispatch(types.REMOVE_SELECTED_SIZE_N_CRUST)
          this.eventTrackingAddToCart(this, pro, 'main', this.$const.CARD_ITEM_TYPE.SINGLE)
          if (this.product.type === this.$const.CARD_ITEM_TYPE.FREE) {
            this.redirectToMenuPage()
          }
        }
      }
    },
    addSelectedExtraTopping(item) {
      if (item.count < this.$const.TOPPING.MAX_PER_TOPPING) {
        this.$store.dispatch(types.ADD_SELECTED_EXTRA_TOPPING, item)
        this.updateTotalPrice()
        this.eventTrackingVariantSelect({item: this.menu, topping: item, first: this.choosedFirst})
      }
    },
    removeSelectedExtraTopping(item) {
      this.$store.dispatch(types.REMOVE_SELECTED_EXTRA_TOPPING, item)
      this.updateTotalPrice()
    },
    resetAddedExtraTopping() {
      this.$store.dispatch(types.RESET_ADDED_EXTRA_TOPPINGS)
    },
    removeSelectedDefaultTopping(item) {
      this.$store.dispatch(types.REMOVE_SELECTED_DEFAULT_TOPPING, item)
      this.eventTrackingVariantUnSelect({item: this.menu, topping: item, first: this.choosedFirst})
    },
    reAddSelectedDefaultTopping(item) {
      this.$store.dispatch(types.RE_ADD_SELECTED_DEFAULT_TOPPING, item)
    },
    resetRemovedDefaultTopping() {
      this.$store.dispatch(types.RESET_REMOVED_DEFAULT_TOPPINGS)
    },
    resetQuantityToppings() {
      this.$store.dispatch(types.RESET_QUANTITY_TOPPINGS)
    },
    deactiveScroll() {
      this.willScroll = false
    },
    setScrollPositionMoveTo(toppingUUID) {
      this.willScroll = true
      this.currentSelectedToppingUuid = toppingUUID
    },
    scrollToItem(uuid) {
      let elTopping = document.querySelectorAll(`[data-item-uuid="${uuid}"]`).item(0)
      elTopping.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth',
      })
    },
    closeModal() {
      this.$emit('close');
      this.resetDataItem();
      // reset state selected Size&Crust in STORE
      this.$store.dispatch(types.REMOVE_SELECTED_SIZE_N_CRUST);
    },
  }
}

</script>
<style scoped>
  .d-none {
    display: none;
  }
  .fade-enter-active,
  .fade-leave-active {
    /* transition: opacity .5s; */
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    /* transition: opacity .3s ease; */
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 300px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    /* transition: all .3s ease; */
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .btn-half {
    margin: 0px 0px 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/ModalPizza.vue